export default __webpack_public_path__ + "static/media/mq.e82d6df9.svg";